import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const ToolConsumerInfo = props => {
  return (
    <Fragment>
      <h3>Tool Consumer Info</h3>
      <ul>
        <li>
          <b>Name:</b> {props.log.params.tool_consumer_instance_name}
        </li>
        <li>
          <b>Contact Email:</b>{' '}
          {props.log.params.tool_consumer_instance_contact_email}
        </li>
        <li>
          <b>Description:</b>{' '}
          {props.log.params.tool_consumer_instance_description}
        </li>
        <li>
          <b>Product Family Code:</b>{' '}
          {props.log.params.tool_consumer_info_product_family_code}
        </li>
        <li>
          <b>Version:</b> {props.log.params.tool_consumer_info_version}
        </li>
        <li>
          <b>GUID:</b> {props.log.params.tool_consumer_instance_guid}
        </li>
        <li>
          <b>URL:</b> {props.log.params.tool_consumer_instance_url}
        </li>
      </ul>
    </Fragment>
  )
}
export default ToolConsumerInfo

ToolConsumerInfo.propTypes = {
  log: PropTypes.object,
}
